import { useState } from 'react'
import {Calculator, Menu, X} from 'lucide-react'

const links = [
  { label: 'Pricing Estimator', href: '#pricing' },
  { label: 'Aspect Ratio', href: '#aspect' },
  { label: 'Vans Formula', href: '#vans' },
  { label: 'Galleries', href: '#galleries' },
  { label: 'Guides', href: '#guides' },
]

function Navbar() {
  const [open, setOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 border-b border-white/5 bg-[#070a13]/80 backdrop-blur-xl">
      <nav
        className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5"
        aria-label="Primary"
      >
        <a href="#top" className="flex items-center gap-2.5 group">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-emerald-400 shadow-lg shadow-indigo-500/30 transition-transform group-hover:scale-105">
            <Calculator className="h-5 w-5 text-[#070a13]" />
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-white">
            logo<span className="text-indigo-400">calculators</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-lg px-3 py-2 text-sm font-medium text-slate-300 transition-colors hover:bg-white/5 hover:text-white"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#pricing"
            className="ml-2 rounded-lg bg-gradient-to-r from-indigo-500 to-emerald-400 px-4 py-2 text-sm font-semibold text-[#070a13] shadow-lg shadow-indigo-500/30 transition-transform hover:scale-105"
          >
            Get a Quote
          </a>
        </div>

        <button
          type="button"
          className="rounded-lg p-2 text-slate-300 hover:bg-white/5 md:hidden"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open ? (
        <div className="border-t border-white/5 bg-[#070a13] px-5 py-3 md:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block rounded-lg px-3 py-2.5 text-sm font-medium text-slate-300 hover:bg-white/5 hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </div>
      ) : null}
    </header>
  )
}

export default Navbar
